import { GuestProfile, MatchField } from '@mews-commander/guest-profile';
import { isMobileOrTablet, WithBreakpointRange } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { EmptyState, Grid, Stack, Typography } from '@optimus-web/core';
import { FieldsRow } from './components';
import { ContainerStyled } from './styles';

const chunkArray = (array: Array<MatchField>, chunkSize: number) => {
    if (!array?.length) {
        return [];
    }

    const nestedArray = [];

    for (let i = 0; i < array.length; i += chunkSize) {
        nestedArray.push(array.slice(i, i + chunkSize));
    }
    return nestedArray;
};

export interface MatchingFieldsProps extends WithBreakpointRange {
    matchedFields: Array<MatchField>;
    matchingProfile: GuestProfile;
}

export const MatchingFields = ({ matchedFields, breakpointRange, matchingProfile }: MatchingFieldsProps) => {
    const smallScreen = isMobileOrTablet(breakpointRange);
    const itemsPerRow = smallScreen ? 2 : 3;
    const nestedArray = chunkArray(matchedFields, itemsPerRow);

    return (
        <Stack vertical spacing="300" itemAlignment="center" fill>
            <Typography textStyle="titleMediumStrong" variant="primary" align="center" as="div">
                {lt('AccountMergeMatchingFieldsHeading')}
            </Typography>
            <ContainerStyled display="block" padding={['300', '800']} width="100%" overflowX="auto">
                {nestedArray.length ? (
                    <Grid templateColumns="1fr">
                        {nestedArray.map((arr, index) => (
                            <FieldsRow
                                matchingFields={arr}
                                isLast={nestedArray.length - 1 === index}
                                values={matchingProfile}
                            />
                        ))}
                    </Grid>
                ) : (
                    <EmptyState primaryText={lt('AccountMergeMatchingFieldsEmptyLabel')} size="medium" />
                )}
            </ContainerStyled>
        </Stack>
    );
};
